<template>
  <div>
    <div class="grey-subhead-bg text-uppercase">
      <h1>Search for your product</h1>
    </div>

    <div class="container">
      <br>
      <div class="row text-center">
        <div class="col-xs-6 col-xs-offset-3">
          <div
            class="no-filters"
            v-if="searchableFields.length === 0"
            >
            <h1>There are no available filters. Continue to view all.</h1>
          </div>
          <div v-else>
            <p>COMPLETE ONE (1) OR MORE OF THE FIELDS BELOW TO SEARCH FOR YOUR ITEM OR CLICK THE CONTINUE BUTTON.</p>
            <div
              class="searchInput"
              v-for="(field, index) in searchableFields" :key="index"
              >
              <input
                v-if="field.field !== 'category'"
                type="text"
                class="form-control client-form-control text-uppercase"
                :placeholder="field.displayName"
                v-model="filters[field.field]">
              <select
                v-else
                class="form-control client-form-control text-uppercase"
                v-model="filters.category">
                <option selected disabled :value="null">Category</option>
                <option
                  v-for="(category, index) in categories"
                  :key="index"
                  :value="category.category">{{category.category}}</option>
              </select>
              <br>
            </div>

          </div>
          <!-- <select class="form-control client-form-control input-lg" v-model="filters.category">
            <option selected disabled value="">Category</option>
            <option
              v-for="(category, index) in categories"
              :key="index"
              :value="category">{{category}}</option>
          </select> -->
          <br>

        </div>
        <div class="clearfix"></div>
        <div class="col-sm-6 col-sm-offset-3">
          <a
            href=""
            type="button"
            class="btn client-btn-primary btn-lg btn-block text-uppercase"
            @click.prevent="goResults"
          >
            Continue
          </a><br>
          <a
            href=""
            type="button"
            class="btn client-btn-primary btn-lg btn-block text-uppercase"
            @click.prevent="goInvoiceDetails"
          >
            <span class="glyphicon-chevron-left glyphicon"></span> Back
          </a>
        </div>
      </div>
      <br><br>
    </div><!-- container-fluid -->
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ItemSearch',
  data () {
    return {
      filters: {
        category: null // have to make exception for category to display select field placeholder
      }
    }
  },
  computed: {
    ...mapState('loyaltyProgram', {
      categories: state => state.program.categories,
      fields: state => state.program.rebateItemFields
    }),
    searchableFields () {
      return this.fields.filter(field => field.searchable)
    }
  },
  methods: {
    goResults () {
      this.$bus.emit('swapComponent', { component: 'item-search-results', props: { filters: this.filters } })
    },
    goInvoiceDetails () {
      this.$bus.emit('swapComponent', { component: 'invoice-details' })
    }
  }
}
</script>
